import React from "react";

export const ProductInfo = props => {

    return (
        <div id="productinfo">
            <p className="desc">{props.desc}</p>
            <p className="produktmerkmal">Produktmerkmale für {props.type}:</p>
            <ul className="desc_items">
                {props.desc_items.map((elem, index) => (
                    <li key={index}><span className="desc_titel">{elem.titel}</span> <span className="desc_item">{elem.item}</span></li>
                ))}
            </ul>
            <p className="price">{props.price}</p>
        </div>
    )
}